const WIZARD_DATA_CACHE_TOKEN_LOCAL_STORAGE_KEY = 'cached-ferry-booking-wizard-data-token';

/*
 * Save the token for the booking wizard data retrieval from the cache.
 */
export function saveBookingWizardDataCacheToken(token: string) {
	localStorage.setItem(WIZARD_DATA_CACHE_TOKEN_LOCAL_STORAGE_KEY, JSON.stringify(token));
}

/*
 * Get the token from local storage used to fetch the booking wizard data from the cache.
 */
export function getBookingWizardDataCacheToken(): string | null {
	const fetchedData = localStorage.getItem(WIZARD_DATA_CACHE_TOKEN_LOCAL_STORAGE_KEY);

	return fetchedData === null ? null : JSON.parse(fetchedData);
}

/*
 * Remove the token from local storage once it has been used.
 */
export function removeBookingWizardDataCacheToken() {
	localStorage.removeItem(WIZARD_DATA_CACHE_TOKEN_LOCAL_STORAGE_KEY);
}
